export default function profileScore(
  initialState = {
    profileScore: 0
  },
  action
) {
  switch (action.type) {
    case 'SET_PROFILE_SCORE':
      return {
        ...initialState,
        profileScore: action.payload
      };

    case 'PROFILE_SCORE_RESET':
      return {
        ...initialState,
        profileScore: 0
      };

    default:
      return initialState;
  }
}
